import { render, staticRenderFns } from "./flat-selector-switch.component.vue?vue&type=template&id=762dd008&scoped=true&lang=pug"
import script from "./flat-selector-switch.component.vue?vue&type=script&lang=ts"
export * from "./flat-selector-switch.component.vue?vue&type=script&lang=ts"
import style0 from "./flat-selector-switch.component.vue?vue&type=style&index=0&id=762dd008&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762dd008",
  null
  
)

export default component.exports